import React from "react";

import "./index.scss";

const ResetPassword: React.FC = () => {
  return <div className="resetpw-form"></div>;
};

export default ResetPassword;
